var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: _vm.title,
            width: 380,
            visible: _vm.visible,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
            maskClosable: false,
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c("a-spin", { attrs: { spinning: _vm.loading } }, [
            _vm.qrData
              ? _c(
                  "div",
                  { staticClass: "qr-wrap" },
                  [
                    _c("div", { staticClass: "qr-table" }, [
                      _vm._v(_vm._s(_vm.qrData.tableName)),
                    ]),
                    _c("img", {
                      staticClass: "qr-img",
                      attrs: {
                        src: "data:image/png;base64," + _vm.qrData.qrBase64,
                        alt: "桌码二维码",
                      },
                    }),
                    _c("div", { staticClass: "qr-store" }, [
                      _vm._v(_vm._s(_vm.qrData.storeName)),
                    ]),
                    _c("div", { staticClass: "qr-type-tip" }, [
                      _vm._v(_vm._s(_vm.typeTip)),
                    ]),
                    _c(
                      "a-radio-group",
                      {
                        staticClass: "qr-format",
                        attrs: { size: "small" },
                        on: { change: _vm.handleFormatChange },
                        model: {
                          value: _vm.qrFormat,
                          callback: function ($$v) {
                            _vm.qrFormat = $$v
                          },
                          expression: "qrFormat",
                        },
                      },
                      [
                        _c("a-radio-button", { attrs: { value: "qr" } }, [
                          _vm._v("普通二维码"),
                        ]),
                        _c("a-radio-button", { attrs: { value: "wxacode" } }, [
                          _vm._v("小程序码"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "qr-btns" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "download" },
                            on: { click: _vm.handleDownload },
                          },
                          [_vm._v("下载二维码")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            on: { click: _vm.handleCancel },
                          },
                          [_vm._v("关闭")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }